import { createReducer } from '@reduxjs/toolkit';

import {
  setJobMode,
  setJobType,
  setJobCity,
  setOrgSlug,
  setJobSlug,
  setJobTitle,
  initialState,
  setJobStatus,
  setJobCountryId,
  setJobCountryName,
  setAllJobProperties
} from '../Actions/jobEditorActions';

import type {
  JobEditorState
} from '../Actions/jobEditorActions';

const jobEditorReducer = createReducer<JobEditorState>(initialState, (builder) => {
  builder
    .addCase(setJobTitle, (state, action) => {
      state.jobTitle = action.payload;
    })
    .addCase(setJobCountryName, (state, action) => {
      state.jobCountryName = action.payload;
    })
    .addCase(setJobCountryId, (state, action) => {
      state.jobCountryId = action.payload;
    })
    .addCase(setJobMode, (state, action) => {
      state.jobMode = action.payload;
    })
    .addCase(setJobType, (state, action) => {
      state.jobType = action.payload;
    })
    .addCase(setJobCity, (state, action) => {
      state.jobCity = action.payload;
    })
    .addCase(setJobStatus, (state, action) => {
      state.jobStatus = action.payload;
    })
    .addCase(setJobSlug, (state, action) => {
      state.jobSlug = action.payload;
    })
    .addCase(setOrgSlug, (state, action) => {
      state.orgSlug = action.payload;
    })
    .addCase(setAllJobProperties, (state, action) => ({ ...state, ...action.payload }));
});

export default jobEditorReducer; 